module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/stack_add_graphic@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/stack_add_graphic@3x.png
// module id = 715
// module chunks = 0